var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topic-detail-data-relation"},[_c('div',{staticClass:"table-bd"},[_c('custom-table',{attrs:{"data":_vm.data,"column":_vm.tableColumn,"height":"100%"},on:{"filter":_vm.filterChange,"sort":_vm.sortChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }